export const VideoModes = {
  VIDEO: 'video',
  PLAYLIST: 'playlist',
};
